<template>
    <div  class="form-1 mt-4">
        <!-- Componentes heredados para la validación de los campos:   -->
        <!-- ValidationObserver : Escucha el envio del formulario para ejecutar las validaciones -->
        <!-- ValidationProvider: Verifica que se cumplan las reglas definidas en el input -->
        <ValidationObserver v-slot="{ handleSubmit }">
            <form class="mt-4 xs:w-4/6 sm:w-5/6 lg:w-4/6 mx-auto leading-tight sm:leading-normal"
            @submit.prevent="handleSubmit(onSubmit)" >
                <div class="flex flex-col space-y-2">
                    <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="firstName"
                            rules="required"
                            v-slot="{errors}"
                        >
                            <input-form
                                :type="'text'"
                                :name="'firstName'"
                                v-model="formInputs.firstName"
                            >
                                NOMBRE*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="secondName"
                            rules="required"
                            v-slot="{errors}"
                        >
                            <input-form
                                :type="'text'"
                                :name="'secondName'"
                                v-model="formInputs.secondName"
                            >
                                SEGUNDO NOMBRE
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="fatherLastName"
                            rules="required"
                            v-slot="{errors}"
                        >
                            <input-form
                                :type="'text'"
                                :name="'fatherLastName'"
                                v-model="formInputs.fatherLastName"
                            >
                                PRIMER APELLIDO*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="motherLastName"
                            rules="required"
                            v-slot="{errors}"
                            >
                            <input-form
                                :type="'text'"
                                :name="'motherLastName'"
                                v-model="formInputs.motherLastName"
                            >
                                SEGUNDO APELLIDO*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="genero"
                            rules="required"
                            v-slot="{errors}"
                        >   
                            <v-select-form
                                :name="'genero'"
                                :options="genders"
                                v-model="formInputs.gender"
                                @input="onGenderChange"
                            >
                                GENERO*
                            </v-select-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="fechaNacimiento"
                            rules="required"
                            v-slot="{errors}"

                        >   
                            <input-form
                                :type="'date'"
                                :name="'fechaNacimiento'"
                                v-model="formInputs.birthdayDate"
                            >
                                FECHA DE NACIMIENTO*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="rfc"
                            rules="required"
                            v-slot="{errors}"

                        >
                            <input-form
                                :type="'text'"
                                :name="'rfc'"
                                v-model="formInputs.rfc"
                            >
                                RFC*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="cellphone"
                            rules="required"
                            v-slot="{errors}"
                        >
                            <input-form
                                :type="'text'"
                                :name="'cellphone'"
                                v-model="formInputs.cellphone"
                            >
                                TELEFONO*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="flex flex-col w-full">
                        <ValidationProvider
                            name="email"
                            rules="required"
                            v-slot="{errors}"
                        >
                            <input-form
                                :type="'text'"
                                :name="'email'"
                                v-model="formInputs.email"
                            >
                                CORREO ELECTRONICO*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="postalCode"
                            rules="required"
                            v-slot="{errors}"
                        >

                            <input-form
                                :type="'text'"
                                :name="'postalCode'"
                                v-model="formInputs.postalCode"
                            >
                                CÓDIGO POSTAL*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="colonia"
                            rules="required"
                            v-slot="{errors}"
                        >   
                            <v-select-form
                                :name="'colonia'"
                                :options="suburbs"
                                v-model="formInputs.suburb"
                                @input="onSuburbChange"
                            >
                                COLONIA*
                            </v-select-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                        <ValidationProvider
                                class="sm:w-1/2"
                                name="stateName"
                                rules="required"
                            v-slot="{errors}"
                        >
                            <input-form
                                :type="'text'"
                                :name="'stateName'"
                                v-model="formInputs.stateName"
                                disabled
                            >
                                ESTADO*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="municipality"
                            rules="required"
                            v-slot="{errors}"
                        >
                            <input-form
                                :type="'text'"
                                :name="'municipality'"
                                v-model="formInputs.municipality"
                                disabled
                            >
                                MUNICIPIO*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>  
                    </div>

                        <!-- Campos adicionales para las personas fisicas -->
                    <div class="flex flex-col w-full">
                        <ValidationProvider
                            name="streetName"
                            rules="required"
                            v-slot="{errors}"
                        >   
                            <input-form
                                :type="'text'"
                                :name="'streetName'"
                                v-model="formInputs.streetName"
                            >
                                CALLE*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>  
                    </div>
                    <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                        
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="streetNumber"
                            rules="required"
                            v-slot="{errors}"
                        >   
                            <input-form
                                :type="'text'"
                                :name="'streetNumber'"
                                v-model="formInputs.streetNumber"
                            >
                                NÚMERO EXTERIOR*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="streetNumber"
                            v-slot="{errors}"
                        >   
                            <input-form
                                :type="'text'"
                                :name="'streetNumber'"
                                v-model="formInputs.streetNumberInterior"
                            >
                                NÚMERO INTERIOR
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full" v-if="formType==='physical' || formType==='legal'">
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="IngresosPromedio"
                            rules="required"
                            v-slot="{errors}"
                        >   
                            <input-form
                                :type="'text'"
                                :name="'IngresosPromedio'"
                                v-model="formInputs.IngresosPromedio"
                            >
                                INGRESOS PROMEDIO MENSUAL*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="GastoMensual"
                            rules="required"
                            v-slot="{errors}"
                        >   
                            <input-form
                                :type="'text'"
                                :name="'GastoMensual'"
                                v-model="formInputs.GastoMensual"
                            >
                                GASTO PROMEDIO MENSUAL*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="flex flex-col w-full" v-if="formType==='physical' || formType==='legal'">
                        <ValidationProvider
                            name="fechaInicio"
                            rules="required"
                            v-slot="{errors}"

                        >   
                            <input-form
                                :type="'date'"
                                :name="'fechaInicio'"
                                v-model="formInputs.FechaInicioActividad"
                            >
                                FECHA DE INICIO DE ACTIVIDADES*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full sm:items-end" v-if="formType==='physical' || formType==='legal'">
                        
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="Actividad"
                            rules="required"
                            v-slot="{errors}"
                        > 
                            <v-select-form
                                :name="'Actividad'"
                                :options="activities"
                                v-model="formInputs.Actividad"

                            >
                                ACTIVIDAD ECONOMICA*
                                
                                <div class="tooltip text-light-blue"><i class="fa-solid fa-circle-info"></i>
                                    <span class="tooltiptext">A que sector economico pertenece tu negocio</span>
                                </div>
                            </v-select-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="ConcentracionClientes"
                            rules="required"
                            v-slot="{errors}"
                        >   
                            <input-form
                                :type="'text'"
                                :name="'ConcentracionClientes'"
                                v-model="formInputs.ConcentracionClientes"
                            >
                                ¿QUÉ PORCENTAJE DE TUS VENTAS ANUALES REPRESENTAN TUS 3 PRINCIPALES CLIENTES?
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full sm:items-end" v-if="formType==='physical' || formType==='legal'">
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="mercado"
                            rules="required"
                            v-slot="{errors}"
                        >   
                        <v-select-form
                            :name="'mercado'"
                            :options="activities"
                            v-model="formInputs.mercado"
                            @input="onSectChange"
                        >
                            ¿DE QUÉ SECTOR ECONÓMICO PROVIENE LA MAYOR PARTE DE TUS INGRESOS?*
                            <div class="tooltip text-light-blue"><i class="fa-solid fa-circle-info"></i>
                                <span class="tooltiptext">Sector economico al que pertenece tu negocio</span>
                            </div>
                            </v-select-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="porcentajeMercado"
                            rules="required"
                            v-slot="{errors}"
                        >   
                            <input-form
                                :type="'text'"
                                :name="'porcentajeMercado'"
                                v-model="formInputs.PorcentajeMercado"
                            >
                                ¿QUÉ PORCENTAJE DE TU VENTA PROVIENE DE ESTE SECTOR?*
                            </input-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div  v-if="formType==='physical'" class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full sm:items-end">
                        <ValidationProvider
                            class="sm:w-1/2"
                            name="Asalariado"
                            rules="required"
                            v-slot="{errors}"
                        >   
                            <radio-form
                                :type="'text'"
                                v-model="formInputs.Asalariado"
                                @change="onAsalariadoCheck"
                            >
                            <br>
                                ¿Es Asalariado?*
                            </radio-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="mt-6 md:mt-2 flex">
                    <label class="checkbox-container">
                        <input
                            type="checkbox"
                            v-model="termsCondition"
                        >
                        <span class="checkmark"></span>
                    </label>
                    <p class="text-sm ml-8">Acepto los <a
                            class="underline"
                            target="_blank"
                            @click="showInfoModal = true"
                        >Términos y condiciones</a> de la Política de privacidad</p>
                </div>
                <div class="mt-6 md:mt-2 flex">
                    <label class="checkbox-container">
                        <input
                            type="checkbox"
                            v-model="personalInformation"
                        >
                        <span class="checkmark"></span>
                    </label>
                    <p class="text-sm ml-8">He leido  la <a
                            class="underline"
                            target="_blank"
                            @click="showInfoModal = true"
                        >autorización</a> y acepto el tratamiento de mis datos personales.</p>
                </div>
                <div class="mt-6 md:mt-2 flex">
                    <label class="checkbox-container">
                        <input
                            type="checkbox"
                            v-model="crediticianHistorial"
                        >
                        <span class="checkmark"></span>
                    </label>
                    <p class="text-sm ml-8">Autorizo la consulta de mi<a
                            class="underline"
                            target="_blank"
                            @click="showInfoModal = true"
                        > historial crediticio.</a></p>
                </div>
                <div class="mt-6 flex flex-col space-y-2 items-center justify-end sm:flex-row sm:space-y-0 sm:space-x-2">    
                    <button
                        type="submit"
                        class="hyundai-button w-40 py-0 h-8"
                        :disabled="availableSend"
                    >Guardar</button>
                </div>
            </form>
        </ValidationObserver>
        <modal-form
            :show="showInfoModal"
            @close="showInfoModal = false"
        >
            <p>texto de pruieba</p>
            <!-- <picture class="w-11/12">
                <source
                    :srcset="`${url}/images/bbva-form-f2/ine_ocr_mobile.png`"
                    media="(max-width: 768px)"
                >
                <source :srcset="`${url}/images/bbva-form-f2/ine_ocr_desktop.png`">
                <img
                    :src="`${url}/images/bbva-form-f2/ine_ocr_mobile.png`"
                    alt="Ejemplo de OCR en INE"
                >
            </picture> -->
        </modal-form>
    </div>
</template>

<script>
// Componentes para las validaciones del formulario
import {
    ValidationProvider,
    ValidationObserver,
} from "vee-validate";

import "../../components/f2/helpers/form_validations";


export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    props: ["activities","formType"],
    

    data() {
        return {
            url: $(".url").text(),
            formComplete: false, // Variable para validar que el formulario esté completo
            // Campos del formulario
            formInputs: {
                firstName:"",
                secondName: "",
                motherLastName:"",
                fatherLastName:"",
                gender: "",
                birthdayDate: "",
                rfc:"",
                cellphone:"",
                postalCode:"",
                email:"",
                stateName:"",
                municipality:"",
                suburb:"",
                streetName:"",
                streetNumber:"",
                streetNumberInterior: "",
                IngresosPromedio:"",
                GastoMensual:"",
                FechaInicioActividad: "",
                Actividad: "",
                Asalariado: false,
                aval: true,
                mercado: "",
                PorcentajeMercado: "",
                ConcentracionClientes: "", 
            },
            genders: [
                {
                    id: 1,
                    description: 'Masculino'
                },
                {
                    id: 2,
                    description: 'Femenino'
                },
            ],
            showInfoModal: false,
            suburbs: [],
            termsCondition: false,
            personalInformation: false,
            crediticianHistorial: false,
        }
    },

    methods:{
        //Metodos para escuchar cuando uno de los inputs cambia respectivamente
        //Metodo que escucha cuando el campo de actividad economica es seleccionada
        onActChange(value){
            this.formInputs.Actividad =  value
        },
        //Metodo que escucha cuando el campo de principal mercado es seleccionado
        onSectChange(value){
            this.formInputs.mercado = value
        },
        //Metodo que escucha cuando el campo de asalariado es seleccionada
        onAsalariadoCheck(value){
            console.log('On asalariado');
            this.formInputs.Asalariado = value
        },
        onGenderChange(value){
            this.formInputs.gender = value
        },
        onSuburbChange(value){
            this.formInputs.suburb = value
            his.formInputs.stateName = value.estado
            this.formInputs.municipality = value.municipio
        },


        onSubmit(){
            console.log('submit')
            //Asignación de los campos para obtener las id de las actividades economicas y principal mercado
         let idActividad =   this.formInputs.Actividad.id
         let idMercado =    this.formInputs.mercado.id
        //Seteo del formdata para quitar la actividad economica y mercado que vienen en el form y agregar unicamente
        //los valores de sus respectivos id's
         const formData = {
                    data: { ...this.formInputs },
                };
                formData
                delete formData.data.Actividad
                delete formData.data.mercado
                formData.data.ActividadEconomica = idActividad
                formData.data.PrincipalMercado = idMercado
                formData.data.suburb = this.formInputs.suburb.description
                formData.data.gender = this.formInputs.gender.description
            //Mandamos el tipo de persona que se registrara
            //1 para persona Fisica
            //2 para persona Moral
            formData.type=1
            if(this.formType === 'physical' ){
            }else if(this.formType === 'legal'){
                formData.type=2
          }
          //Emitimos el evento para guardar  a la persona en el componente de AbcRegister
          this.$emit("add-person", formData);
        },
        getRfc(){
            this.formInputs.rfc = this.formInputs.fatherLastName !== undefined ? this.formInputs.fatherLastName.substring(0, 2).toUpperCase() : ''
            this.formInputs.rfc += this.formInputs.motherLastName !== undefined ? this.formInputs.motherLastName.substring(0, 1).toUpperCase() : ''
            this.formInputs.rfc += this.formInputs.firstName !== undefined ? this.formInputs.firstName.substring(0, 1).toUpperCase() : ''
            if(this.formInputs.birthdayDate != ''){
                const birthdayDate = this.formInputs.birthdayDate.split('-')
                this.formInputs.rfc += birthdayDate[0].substring(2) + birthdayDate[1] + birthdayDate[2]
            }
        }
    },
    watch: {
        'formInputs.firstName'(){
            this.getRfc()
        },
        'formInputs.motherLastName'(){
            this.getRfc()
        },
        'formInputs.fatherLastName'(){
            this.getRfc()
        },
        'formInputs.birthdayDate'(){
            this.getRfc()
        },
        'formInputs.postalCode'(value){
            axios.get(`${this.url}/abc/getSuburb/${value}`)
            .then((res)=>{
                this.suburbs = res.data.data.map(e => new Object({
                    id: e.id, 
                    description: e.asentamiento,
                    estado: e.estado,
                    municipio: e.municipio
                }))
                this.formInputs.stateName = this.suburbs[0].estado
                this.formInputs.municipality = this.suburbs[0].municipio
            })
        }
        
    },
    computed: {
        availableSend: function(){
            return !(this.termsCondition && this.crediticianHistorial && this.personalInformation)
        }
    }

}
</script>

<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
    visibility: hidden;
    width: 15rem;
    background-color: #c4c4c4f0;
    color: black;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    top: -0.8rem;
    left: 1.25rem;
    font-size: 0.8rem;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

button:disabled {
    background-color: #324f718e;
    cursor: default;
}

</style>